import {useColorScheme} from "@mui/material/styles";
import {useEffect} from "react";


const ThemeSettings = ({ modeName }) => {
    const { mode, systemMode, setMode } = useColorScheme()
    useEffect(() => {
        setMode(modeName || 'light')
    }, [setMode, modeName])
    return (<></>)
}

export default ThemeSettings
